"use client"

import { Progress } from "@shared/ui"

import { Metric } from "../../types"

interface ProgressMetricProps extends Metric {
  size?: number
}

export function ProgressMetric({
  value,
  color,
  label,
  size = 100,
}: ProgressMetricProps) {
  return (
    <div className="flex flex-col items-center gap-6">
      <Progress
        size={size}
        value={value}
        variant="circular"
        color={color}
        labelClassName="text-lg font-[300] text-black"
      />
      <label className="text-sm font-medium text-gray-500">{label}</label>
    </div>
  )
}
